import { useState } from "react"
import {
  Wrapper,
  Background,
  Label,
  InputContainer,
  FormInput,
  AppendText,
  FormError,
  FormInfo,
  InfoIcon,
  ErrorIcon,
} from "./Input.styles"
import PropTypes from "prop-types"
import { useUniqueId } from "@hornet-web-react/core/utils"

export default function Input(props) {
  // consume some props and leave the attrs
  const {
    className,
    name,
    label,
    value,
    onChange,
    inputRef,
    appendText,
    customValidation,
    children,
    hasShortErrors,
    ...attrs
  } = props

  const [errorMessage, setErrorMessage] = useState("")

  const inputUniqueId = useUniqueId(name)

  const validate = (element, showMessage = false) => {
    if (typeof customValidation === "function") {
      let customValidationMessage = customValidation(element.value)

      if (customValidationMessage !== "") {
        setTimeout(() => {
          setErrorMessage(customValidationMessage)
          element.setCustomValidity(customValidationMessage)
        }, 1)
        return
      }
    }

    if (!element.validity.valid && showMessage) {
      setTimeout(() => setErrorMessage(element.validationMessage), 100)
      return
    }

    setErrorMessage("")
    element.setCustomValidity("")
  }

  const onInput = (e) => {
    validate(e.target)

    onChange(e.target.value, e.target.name, e)
  }

  const onBlur = (e) => {
    validate(e.target, true)
  }

  return (
    <Wrapper className={className}>
      <Background
        hasError={errorMessage}
        className={`form-input__background ${
          errorMessage ? "form-input__background--has-error" : ""
        }`}
      >
        {label && (
          <Label isRequired={attrs.required === true} htmlFor={inputUniqueId}>
            {label}
          </Label>
        )}
        <InputContainer>
          <FormInput
            name={name}
            value={value}
            onInput={onInput}
            onBlur={onBlur}
            ref={inputRef}
            hasError={errorMessage}
            {...attrs}
            id={inputUniqueId}
          />

          {appendText && <AppendText>{appendText}</AppendText>}
        </InputContainer>
      </Background>

      {hasShortErrors !== true && errorMessage && (
        <FormError>
          <ErrorIcon />
          {errorMessage}
        </FormError>
      )}

      {children && (
        <FormInfo>
          <InfoIcon />
          {children}
        </FormInfo>
      )}
    </Wrapper>
  )
}

Input.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  customValidation: PropTypes.func,
  onKeyDown: PropTypes.func,
  autoFocus: PropTypes.bool,
  required: PropTypes.any,
  appendText: PropTypes.any,
  children: PropTypes.any,
  inputRef: PropTypes.any,
}
